import * as moment from "moment";

/**
 * @description 将表单项树结构转换为扁平结构
 * @param formItemTree {Array}
 * @return Array
 */
export function flatFormItem(formItemTree) {
  return formItemTree.reduce((result, item) => {
    if (item.name === "SpanLayout") {
      return result.concat(flatFormItem(item.props.items));
    } else {
      return result.concat(item);
    }
  }, []);
}

export function formatTime(row, column) {
  if (row[column.property] === null) {
    return "";
  }
  return moment(row[column.property]).format("YYYY-MM-DD HH:mm:ss");
}

// 业务状态映射：text 用于展示，type 用于 el-tag 上色
const businessStatusMap = {
  "1": { text: "审核中", type: "primary" }, // 蓝：处理中
  "2": { text: "已撤销", type: "info" },    // 灰：已撤销
  "3": { text: "已驳回", type: "danger" },  // 红：已驳回
  "4": { text: "已通过", type: "success" }, // 绿：已通过
};

export function formatBusinessStatus(row, column) {
  const info = businessStatusMap[row[column.property]];
  return info ? info.text : row[column.property];
}

/**
 * 返回状态信息 { text, type }，type 直接作为 el-tag 的 type
 */
export function businessStatusInfo(status) {
  return businessStatusMap[status] || { text: status || "", type: "info" };
}
export function selectBusinessStatusList() {
  return [
    {id:1,name:"审核中"},{id:2,name:"已撤销"},
    {id:3,name:"已驳回"},{id:4,name:"已通过"}
  ]
}
